import {observable,toJS} from "mobx";
import SettingsService from "../services/Settings.js";
import { message } from "antd";class Settings {
    @observable settings = [];  // 所有实验室气泡图数据
    @observable name = "实验报告系统";  // 系统名称
    @observable logo = "";  // 系统logo
    @observable tags = [];  //封存的账号信息
    constructor(){
        this.getSettings();
    }
    
    getSettings = async () => {
            const settings=await SettingsService.getSettings();
            const nameInfo=settings.find(item=>item.key==="name");
            const logoInfo=settings.find(item=>item.key==="logo");
            const tagsInfo=settings.find(item=>item.key==="tags")||{};
            this.tags=tagsInfo.value?tagsInfo.value.split(","):[];
            this.name=nameInfo?nameInfo.value:"";
            this.logo=logoInfo?logoInfo.value:"";
            window.localStorage.setItem("name",this.name);
            window.localStorage.setItem("logo",this.logo);
    }

    changeSetting = async () => {
        const settings = [
            {key: "name", value: this.name},
            {key: "logo", value: this.logo}
        ];
        await SettingsService.update(settings);
        window.localStorage.setItem("name",this.name);
        window.localStorage.setItem("logo",this.logo);
        message.success("修改成功");
    }
    changeUserTags = async (tags) => {
        this.tags = tags;
        //tags数组转换为字符串
        tags=tags.join(",");
        const settings = [
            {key: "tags", value: tags}
        ];
        await SettingsService.update(settings);
        message.success("修改成功");
    }

}

export  const settingStore= new Settings()